import {
  Button,
  DialogContentText,
  Grid,
  SvgIcon,
  TextField,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import BlockIcon from "@mui/icons-material/Block";
import CallIcon from "@mui/icons-material/Call";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import EmailIcon from "@material-ui/icons/Email";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import SmsIcon from "@mui/icons-material/Sms";
import { MarginOutlined } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";
import { ReactComponent as Logo } from "../images/discountRequest.svg";
import http from "../services/httpService";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  investorActivityLogPath,
  investmentDiscountPath,
  investmentPersonalProfilePath,
  investmentSatisfactionPath,
  investorInvestmentProfilePath,
  investorindividualRequestPath,
  investmentReferalDashboardPath,
  subscriptionManagerPath,
  editInvestorQuestioner,
  goalsDashboardPath,
  investmentPath,
  investorcommunicationTimeLinePath,
  investorCreateNotificationPath,
  investorCreateEmailPath,
  investorNotifiCationManagerPath,
  getDate,
  searchFilter,
  handleSort,
  investmentAddPaymentPath,
  editInvestPath,
  investmentsPath,
  investmentAddSubscriptionPath,
  notesReview,
  addpaymentlinks,
  checkstatutracking,
  onboardingoverviewPath,
} from "../utils/varialbles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { CancelOutlined } from "@material-ui/icons";
import { MenuItem, Select } from "@mui/material";

const useStyles = makeStyles({
  root: {
    width: "100%",
    backgroundColor: "#F5F7FA",
    padding: "7px",
  },
  tile: {
    height: "80px",
    backgroundColor: "#F5F7FA",
    textAlign: "center",
    width: "80%",
    cursor: "pointer",
    color: "#393939",
    padding: "5%",
    "&:hover": {
      backgroundColor: "#3f51b5",
      color: "#F5F7FA",
    },
  },
  analyticwindow: {
    backgroundColor: "#F5F7FA",
    color: "#393939",
    width: "300px",
  },
  button: {
    marginRight: "5px",
    borderRadius: "10px",
  },
});

let ReferralLink = null;
let goalsEnableBtn = false;
let changebgColorGoalAdvice = false;
function InvestmentDetails() {
  let history = useHistory();
  const [noteval, setNoteval] = useState("");
  const [callBtnDisable, setCallBtnDisable] = useState(false);
  const classes = useStyles();
  const [Prospect_Basic_info, setProspect_Basic_info] = useState({});
  const [Prospect_Assigned_info, setProspect_Assigned_info] = useState({});
  const [Prospect_questionnaire, setProspect_questionnaire] = useState({});
  const [call_Analytics, setcall_Analytics] = useState({});
  const [showWindow, setShowWindow] = useState(false);
  const location = useLocation();
  const myparam = location.state;
  const [open, setOpen] = useState(false);
  const [openReferralModal, setRefreealModal] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [block, setBlock] = useState(null);
  const [email, setEmail] = useState(null);
  const [openGoalsModal, setOpenGoalsModal] = useState(null);

  const handleClose = () => {
    setOpen(false);
    setRefreealModal(false);
    setOpenGoalsModal(!openGoalsModal);
  };
  const note = { note: noteval };
  const callCustomer = (e) => {
    e.preventDefault();

    if (myparam && myparam.customer_id) {
      setCallBtnDisable(true);
      http
        .get("/callrequest?cust_id=" + myparam.customer_id + "&location=I")
        .then((res) => {
          if (res && res.data && res.data.Data && res.data.statusCode === 0) {
            toast.success(
              "Call Request Placed successfully,Please wait for the call..!"
            );
          } else {
            toast.error("Call Request Failed");
          }
        })
        .catch((err) => {
          toast.error("Call Request Failed");
        });
    }
  };

  const getCommunication = (e) => {
    e.preventDefault();

    if (myparam && myparam.customer_id) {
      setCallBtnDisable(false);
      history.push({
        pathname: investorcommunicationTimeLinePath,
        state: myparam,
      });
    }
  };
  const gotoGoalsDashBoard = (e) => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: goalsDashboardPath,
        state: myparam,
      });
    }
  };
  const gotoActivityLog = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: investorActivityLogPath,
        state: myparam,
      });
    }
  };
  const sendNotifiCation = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: investorCreateNotificationPath,
        state: myparam,
      });
    }
  };
  const gotoInvestmentProfile = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: investorInvestmentProfilePath,
        state: myparam,
      });
    }
  };

  const gotoReferalDashboard = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: investmentReferalDashboardPath,
        state: myparam,
      });
    }
  };

  const gotoPersonalProfile = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: investmentPersonalProfilePath,
        state: myparam,
      });
    }
  };

  const gotoInvestAddSub = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: investmentAddSubscriptionPath,
        state: myparam,
      });
    }
  };

  const gotoInvestAddpayment = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: investmentAddPaymentPath,
        state: myparam,
      });
    } else {
      //alert(3);
    }
    // if(myparam.cust__id){
    //     alert('recieved myparam');
    // }
    // else{
    //     alert('not received');
    // }
    // //alert(1);
    // // history.push({
    // //     "pathname": investmentAddPaymentPath, state: customer_id

    // // });
  };
  const gotoRequestDiscount = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: investmentDiscountPath,
        state: myparam,
      });
    }
  };

  const gotoProspectSatisfaction = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: investmentSatisfactionPath,
        state: myparam,
      });
    }
  };

  const gotoSubscriptionManager = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: subscriptionManagerPath,
        state: myparam,
      });
    }
  };

  const blockUser = (e) => {
    if (myparam && myparam.customer_id) {
      setOpen(true);
      setCurrentUser(myparam.First_Name);
    } else {
      setCurrentUser(null);
    }
  };

  const goalsModalOpen = (e) => {
    if (myparam && myparam.customer_id) {
      setOpenGoalsModal(true);
      setCurrentUser(myparam.First_Name);
    } else {
      setCurrentUser(null);
    }
  };

  const submitBlock = (e) => {
    if (myparam && myparam.customer_id) {
      http
        .patch("/blockuser?id=" + myparam.customer_id)
        .then((res) => {
          setOpen(false);
          if (res && res.data && res.data.Data) {
            toast.success(res.data.Data);
            handleCancel();
          }
        })
        .catch((err) => {});
    }
  };

  const editQuestioner = (e) => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: editInvestorQuestioner,
        state: myparam,
      });
    }
  };

  const sendEmail = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: investorCreateEmailPath,
        state: myparam,
      });
    }
  };

  const gotoNotifictionManager = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: investorNotifiCationManagerPath,
        state: myparam,
      });
    }
  };

  const gotoRequestSection = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: investorindividualRequestPath,
        state: myparam,
        string: "investmentDetailsPage",
        userid: Prospect_Basic_info.UserID,
      });
    }
  };

  let userQuestionnaire = [
    // { "lable": "Source Channel*", "filedType": "dropDown" },
    {
      lable: "How did you get to know about Savart?",
      filedType: "dropDown",
      value: "enquiry",
    },
    {
      lable: "Communication Preference",
      filedType: "dropDown",
      value: "communication",
    },
    {
      lable: "Was he/ She interested in the services?",
      filedType: "dropDown",
      value: "interest",
    },
    {
      lable: "If not interested, what was the reason for disinterest?",
      filedType: "text",
      value: "reason_notinterest",
    },
    {
      lable: "Was he/ She polite with communication",
      filedType: "dropDown",
      value: "politeness",
    },
    {
      lable: "Family background",
      filedType: "text",
      value: "family_background",
    },
    { lable: "Goal Details", filedType: "text", value: "goal" },
    {
      lable: "Have you ever invested before?",
      filedType: "dropDown",
      value: "previous_investment",
    },
    {
      lable: "If yes, How was your experience?",
      filedType: "text",
      value: "inv_exp",
    },
    {
      lable: "If yes, with which broker? what was the quantum?",
      filedType: "text",
      value: "broker_quantum",
    },
    {
      lable: "If yes, with which adivisor? what was the quantum?",
      filedType: "text",
      value: "advisor_quantum",
    },
    // { "lable": "Prospect Location", "filedType": "dropDown" ,"value":"loc_country"},
  ];

  const setFriendlyBtn = (e) => {
    if (myparam && myparam.customer_id) {
      http
        .patch("/friendly?id=" + myparam.customer_id)
        .then((res) => {
          if (res && res.data && res.data.Data) {
            toast.success(res.data.Data);
            handleCancel();
          } else {
            toast.error("Unable to Set Friendly..!");
          }
        })
        .catch((err) => {
          toast.error("Unable to Set Friendly..!");
        });
    }
  };
  const submitGoalAdvices = (e) => {
    if (myparam && myparam.customer_id) {
      http
        .post(
          `inactive_goals?cust_id=${myparam.customer_id}&status=${changebgColorGoalAdvice}`
        )
        .then((res) => {
          setOpenGoalsModal(!openGoalsModal);
          if (res.data.statusCode === 0) {
            toast.success(res.data.data);
            setOpenGoalsModal(!openGoalsModal);
            handleCancel();
          }
        })
        .catch((err) => {
          toast.error("Unable to Set Friendly..!");
        });
    }
  };

  const [cus_id, setcus_id] = useState("");

  const [tagData, setTagData] = useState([]);
  const [currentTagData, setCurrentTagData] = useState([]);

  const [showPMsOPtions, setShowPMSOptions] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedRadioTags, setSelectedRadioTags] = useState([]);

  useEffect(() => {
    goalsEnableBtn = false;
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("internalFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("selectedfiltersdata");

    if (myparam && myparam.customer_id) {
      let cust_id = myparam.customer_id;
      //alert(cust_id + ' hello');
      setcus_id(cust_id);
    }
    handleCancel();

    http
      .get(`customertags/${myparam.customer_id}/`)
      .then((res) => {
        setTagData(res.data.data.all_tags);
        setCurrentTagData(res.data.data.current_tags);
      })
      .catch((err) => {
        console.log(err);
      });
    const inputs = document.querySelectorAll("input");

    inputs.forEach((input) => {
      currentTagData.forEach((item) => {
        if (item.name === input.id) {
          input.checked = true;
        }
      });
    });
  }, [showPMsOPtions]);

  const sendOtp = () => {
    const baseUrl = "/sendOTP";
    http
      .get(`${baseUrl}?cust_id=${cus_id}`)
      .then((res) => {
        const statusCode = res.data.statusCode;
        if (statusCode === 0) {
          // (res.data.Data);
          toast.success(res.data.Data);
        }
      })
      .catch((err) => {
        // (err)
      });
  };

  const handleCancel = () => {
    if (myparam && myparam.customer_id) {
      let cust_id = myparam.customer_id;
      //alert(cust_id);
      http
        .get("/investor_detail_view/" + cust_id + "/")
        .then((res) => {
          // (res);
          setEmail(res.data.Email);
          ReferralLink = res.data.Referral;
          setBlock(res.data.Block);
          if (res && res.data && res.data.data && res.data.data.length > 0) {
            setProspect_Basic_info(res.data.data[0]);
            goalsEnableBtn = res.data.data[0].goals !== 0 ? true : false;
            changebgColorGoalAdvice =
              res.data.data[0].goal_enable === null ||
              res.data.data[0].goal_enable === false
                ? 1
                : 0;
            if (res.data.questionnaire && res.data.questionnaire.length > 0) {
              setProspect_questionnaire(res.data.questionnaire[0]);
            }
            setShowWindow(true);
          } else {
            toast.error("Investor Data Not Found..!");
            // history.push(investmentPath)
          }

          if (res.data.note != null) {
            // setNoteval(res.data.note);
          }
        })
        .catch((err) => {
          toast.error(err);
        });
    } else {
      // toast.error("Investor Data Not Found..!");
      history.push(investmentPath);
    }
  };

  const editinvest = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: editInvestPath,
        state: myparam,
      });
    }
  };

  const investments = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: investmentsPath,
        state: myparam,
      });
    }
  };

  // console.log(location.state, "manager");

  const gobackpage = (e) => {
    e.preventDefault();
    if (localStorage.getItem("manager") === "onboarding") {
      history.push({
        pathname: onboardingoverviewPath,
      });
    } else if (location.backString === "invImportant") {
      history.push({
        pathname: investmentPath,
        state: { tab: "Important" },
      });
    } else if (myparam && myparam.customer_id) {
      history.push({
        state: {
          page: myparam.page,
        },
        pathname: investmentPath,
      });
    }
  };

  const CHARACTER_LIMIT = 2000;

  const handleChange = (e) => {
    setNoteval(e.target.value);
  };

  const handleUpdate = (e) => {
    http
      .post("/saveNote/" + myparam.customer_id + "/", note)
      .then((response) => {
        if (response.data.statusCode === 0) {
          // toast.success("Note Added");

          toast.success(response.data.data);
          setNoteval("");
        }

        // setFromObject(form)
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // (myparam.customer_id);

  const copyReferral = () => {
    let edxfcgv = navigator.clipboard.writeText(ReferralLink);
    toast.success("Text Copied Successfully");
    setRefreealModal(!openReferralModal);
  };

  const gotoNotesReviewPage = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: notesReview,
        state: myparam,
      });
    }
  };

  const gotoaddPaymentLinksPage = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: addpaymentlinks,
        state: myparam,
      });
    }
  };

  const gotoaddStatusTrackPage = () => {
    if (myparam && myparam.customer_id) {
      history.push({
        pathname: checkstatutracking,
        state: myparam,
      });
    }
  };

  const [getGst, setGst] = useState("");

  const gstOnChange = (e) => {
    setGst(e.target.value);
  };

  let GSTregex = new RegExp(
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
  );

  const [openGstModel, setOpenGstModel] = useState(false);
  const [GstCustName, setGstCustName] = useState("");

  const submitGSTName = () => {
    if (GstCustName) {
      http

        .get(
          `/add_GSTIN/` +
            myparam.customer_id +
            `?gstin=${getGst}&name=${GstCustName}`
        )

        .then((res) => {
          if (res.data.statusCode === 0) {
            toast.success(res.data.data);
          } else {
            toast.error(res.data.error);
            setOpenGstModel(false);
          }
        })

        .catch((err) => {
          console.log(err);
        });
    } else {
      toast.error("Please enter name");
    }
  };

  const submitGST = (e) => {
    if (getGst.length !== 15 || getGst.length > 15) {
      toast.error("GST number should have length 15");
    }

    if (!GSTregex.test(getGst)) {
      toast.error("This is not a proper GST number");
    }

    if (GSTregex.test(getGst)) {
      setOpenGstModel(true);
    }
  };

  const [tagValue, setTagValue] = useState("");

  const handleTagChange = (e) => {
    setTagValue(e.target.value);
  };

  const handlePmsTag = (e, itemName) => {
    if (e.target.checked) {
      setSelectedTags((prevSelectedTags) => [...prevSelectedTags, itemName]);
    } else {
      // Remove the tag from the selectedTags array if unchecked
      setSelectedTags((prevSelectedTags) =>
        prevSelectedTags.filter((tag) => tag !== itemName)
      );
    }
  };

  const handlePmsRadioTag = (e, itemName) => {
    const input = document.getElementById(itemName);

    if (itemName === "PMS" && input.checked) {
      document.getElementById("PIA").checked = false;
      setSelectedRadioTags([e.target.value]);
    }
    if (itemName === "PIA" && input.checked) {
      document.getElementById("PMS").checked = false;
      setSelectedRadioTags([e.target.value]);
    }

    if (itemName === "PMS" && !input.checked) {
      setSelectedRadioTags([]);
    }

    if (itemName === "PIA" && !input.checked) {
      setSelectedRadioTags([]);
    }
  };

  const toggleSelect = () => {
    setShowPMSOptions((val) => !val);
    const tagNames = currentTagData.map((tag) => tag.name);

    tagNames.forEach((item) => {
      if (item === "PMS" || item === "PIA") {
        setSelectedRadioTags([item]);
      } else {
        setSelectedTags((prevTags) => [...prevTags, item]);
      }
    });
  };

  const saveSelectedTags = () => {
    let postObj = {};
    if (selectedRadioTags.length === 0 && selectedRadioTags === 0) {
      postObj = {
        selected_tags: "Untagged",
      };
    } else {
      postObj = {
        selected_tags: [...selectedTags, ...selectedRadioTags].join(","),
      };
    }
    http
      .post(`customertags/${myparam.customer_id}/`, postObj)
      .then((res) => {
        toast.success(res.data.data);
        setShowPMSOptions(false);
        handleCancel();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Grid
      container
      style={showWindow ? { display: "block" } : { display: "none" }}
    >
      {/* <Paper className={classes.root,"paper"} >className="pb30"
                <Grid container className={'overviewbar'}>
                <Grid item xs={12} sm={5} md={7} lg={8} xl={9} >
                        <Button name="Overview" variant="contained" color="primary" onClick={e=> history.push(investmentPath)}>Overview</Button>
                    </Grid>
                    <Grid item xs={12} sm={5} md={3} lg={3} xl={2} >
                        <Button name="Overview" variant="contained" color="primary" style={{  borderRadius: "10px",float:"right" }} onClick={gotoInvestAddpayment}>Add Payment                            
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={5} md={3} lg={3} xl={2} >
                        <Button name="Overview" variant="contained" color="primary" style={{  borderRadius: "10px",float:"right" }} onClick={gotoRequestDiscount}>Request Discount
                            <span style={{ paddingLeft: "15px",marginTop:5 }}>
                                <SvgIcon >
                                    <Logo />
                                </SvgIcon>
                            </span>
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2}  lg={1} xl={1} >
                        <Button variant="contained" color={Prospect_Basic_info.blocked?"primary":'secondary'} startIcon={<BlockIcon variant="outlined" />} style={{ borderRadius: "10px" }} onClick={blockUser} 
                        >{Prospect_Basic_info.blocked?"UnBlock":"Block"}</Button>
                    </Grid>
                </Grid>
            </Paper> */}
      {/* <Grid container style={{ marginTop: "10px" }}>
                <Grid item xs={12} sm={2} md={3} lg={2} xl={3} className={'overviewbar'}>
                    <Typography  variant="h6">
                        {((Prospect_Basic_info.Customer_Name) ? Prospect_Basic_info.Customer_Name : "N/A") + " " + ((Prospect_Basic_info.UserID) ? Prospect_Basic_info.UserID : "N/A")}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={2} md={2} lg={3} xl={4} className={'overviewbar'}>
                    <Typography  variant="h6">
                        RM Name - {Prospect_Basic_info.Assigned_Executive}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={8} md={7} lg={7} xl={5} className={'overviewbar'} >
                    <Button variant="contained" color="primary" className={classes.button} onClick={getCommunication}>Communication Timeline</Button>
                    <Button variant="contained" color="primary" className={classes.button} disabled={callBtnDisable} onClick={callCustomer} endIcon={<CallIcon variant="outlined" />}>Call</Button>
                    <Button variant="contained" color="primary" className={classes.button} endIcon={<EmailIcon variant="outlined" />} onClick={sendEmail}>Email</Button>
                    <Button variant="contained" color="primary" className={classes.button} endIcon={<SmsIcon variant="outlined" />} disabled>Sms</Button>
                    <Button variant="contained" color="primary" className={classes.button} endIcon={<NotificationsActiveIcon variant="outlined" />} onClick={sendNotifiCation}> Notify</Button>
                </Grid>

            </Grid>
            <Grid container style={{ marginTop: "20px" }}>
            <Grid item xs={12} sm={2} md={2} className={'overviewbar'}>
                    <Typography  variant="body1">EFG Score - : {Prospect_Basic_info.EFG_Score}</Typography>
                </Grid>
                <Grid item xs={12} sm={2} md={2} className={'overviewbar'}>
                    <Typography  variant="body1">Expiry Date : {Prospect_Basic_info.Expiry}</Typography>
                </Grid>
                <Grid item xs={12} sm={2} md={4} className={'overviewbar'}>
                    <Typography  variant="body1">Number of days to expiry : {Prospect_Basic_info.Daystoexpiry}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4} align="right" className={'overviewbar'}>
                    <Button name="Overview" variant="contained" color="primary" style={{ width: "400px", borderRadius: "10px" }} onClick={gotoNotifictionManager}>Notification History
                    </Button>
                </Grid>
            </Grid> */}

      <div className="menuhead">
        {/* <button onClick={gobackpage}>Back</button> */}
        <Button
          variant="outlined"
          color="default"
          startIcon={<ArrowBackIosIcon />}
          style={{ height: "40px", marginLeft: 5, marginRight: 15 }}
          onClick={gobackpage}
        >
          Back
        </Button>
        <button
          className="ovrbtn"
          // onClick={(e) => history.push(investmentPath)}
        >
          Overview
        </button>
        {localStorage.getItem("empRole") === "MF Manager" ||
        localStorage.getItem("empRole") === "MF Executive" ||
        localStorage.getItem("empRole") === "Franchise" ? (
          ""
        ) : (
          <button
            className="ovrbtn"
            onClick={investments}
            style={{ marginLeft: "30px", borderBottom: "transparent" }}
          >
            Investments
          </button>
        )}
      </div>

      <div className="menuheadchild">
        <div style={{ fontSize: "24px", color: "#393939", fontWeight: "bold" }}>
          {(Prospect_Basic_info.Customer_Name
            ? Prospect_Basic_info.Customer_Name
            : "N/A") +
            " " +
            (Prospect_Basic_info.UserID
              ? Prospect_Basic_info.UserID
              : "N/A")}{" "}
        </div>

        <div className="menuchildbtns">
          {(localStorage.getItem("empRole") === "CTO" ||
            localStorage.getItem("empRole") === "CEO" ||
            localStorage.getItem("empRole") === "Sales Manager" ||
            localStorage.getItem("empRole") === "BTL Manager") && (
            <>
              <button className="button" onClick={gotoInvestAddSub}>
                Add Subscription
              </button>
            </>
          )}

          {(localStorage.getItem("empRole") === "CTO" ||
            localStorage.getItem("empRole") === "CEO" ||
            localStorage.getItem("empRole") === "Sales Manager" ||
            localStorage.getItem("empRole") === "CRT Executive" ||
            localStorage.getItem("empRole") === "CRT Manager" ||
            localStorage.getItem("empRole") === "MF Manager" ||
            localStorage.getItem("empRole") === "MF Executive" ||
            localStorage.getItem("empRole") === "Franchise") && (
            <>
              <button className="button" onClick={sendOtp}>
                send OTP
              </button>
              <button className="button" onClick={gotoInvestAddpayment}>
                Create Payment Link
              </button>
            </>
          )}
          {(localStorage.getItem("empRole") === "CTO" ||
            localStorage.getItem("empRole") === "CEO" ||
            localStorage.getItem("empRole") === "Sales Manager" ||
            localStorage.getItem("empRole") === "Business Growth Executive" ||
            localStorage.getItem("empRole") === "BTL Executive" ||
            localStorage.getItem("empRole") === "CRT Executive" ||
            localStorage.getItem("empRole") === "CRT Manager" ||
            localStorage.getItem("empRole") === "BTL Manager") && (
            // localStorage.getItem("empRole") === "MF Manager" ||
            // localStorage.getItem("empRole") === "Franchise"
            <>
              <button className="button" onClick={gotoRequestDiscount}>
                <span>Request Discount </span>
                <span style={{ paddingLeft: "9px", display: "flex" }}>
                  <SvgIcon>
                    <Logo />
                  </SvgIcon>
                </span>
              </button>
            </>
          )}

          {localStorage.getItem("empRole") === "MF Manager" ||
          localStorage.getItem("empRole") === "MF Executive" ||
          localStorage.getItem("empRole") === "Franchise" ? (
            ""
          ) : (
            <>
              {email ? (
                <button className="button" onClick={sendEmail}>
                  <span>Email</span>{" "}
                  <span style={{ paddingLeft: "9px", display: "flex" }}>
                    {" "}
                    <EmailIcon />{" "}
                  </span>
                </button>
              ) : null}

              {(localStorage.getItem("empRole") === "CTO" ||
                localStorage.getItem("empRole") === "CEO" ||
                localStorage.getItem("empRole") === "Sales Manager") && (
                <>
                  {" "}
                  <button className="button" onClick={sendNotifiCation}>
                    <span>Notify</span>{" "}
                    <span style={{ paddingLeft: "9px", display: "flex" }}>
                      {" "}
                      <NotificationsActiveIcon />{" "}
                    </span>
                  </button>
                </>
              )}
              <button
                className="button"
                onClick={() => {
                  setRefreealModal(true);
                }}
              >
                <span>Referral</span>{" "}
                <span style={{ paddingLeft: "9px", display: "flex" }}>
                  {" "}
                  {/* <NotificationsActiveIcon />{" "} */}
                </span>
              </button>

              <button className="button" onClick={gotoNotifictionManager}>
                Notification History
              </button>

              {localStorage.getItem("empRole") === "Sales Manager" ||
              localStorage.getItem("empRole") === "CTO" ||
              localStorage.getItem("empRole") === "CEO" ? (
                <>
                  {block ? (
                    <Button
                      variant="contained"
                      className="button"
                      color={
                        Prospect_Basic_info.blocked ? "primary" : "secondary"
                      }
                      startIcon={<BlockIcon variant="outlined" />}
                      style={{ borderRadius: "10px" }}
                      onClick={blockUser}
                    >
                      {Prospect_Basic_info.blocked ? "UnBlock" : "Block"}
                    </Button>
                  ) : null}
                </>
              ) : (
                ""
              )}
            </>
          )}
          {localStorage.getItem("empRole") === "MF Manager" ||
          localStorage.getItem("empRole") === "MF Executive" ||
          localStorage.getItem("empRole") === "Franchise" ? (
            ""
          ) : (
            <button className="button" onClick={callCustomer}>
              <span>Call</span>{" "}
              <span style={{ paddingLeft: "9px", display: "flex" }}>
                {" "}
                <CallIcon />{" "}
              </span>
            </button>
          )}
          {localStorage.getItem("empRole") === "CTO" ? (
            <>
              {goalsEnableBtn ? (
                <Button
                  variant="contained"
                  className={
                    changebgColorGoalAdvice === 1
                      ? "advicegreenbtn"
                      : "advicesss_button"
                  }
                  // startIcon={<BlockIcon variant="outlined" />}
                  style={{ borderRadius: "10px" }}
                  onClick={goalsModalOpen}
                >
                  Goal Advice
                </Button>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}
        </div>
      </div>

      {localStorage.getItem("empRole") === "MF Manager" ||
      localStorage.getItem("empRole") === "MF Executive" ||
      localStorage.getItem("empRole") === "Franchise" ? (
        ""
      ) : (
        <div className="prospectdetails investmentdetails">
          <div className="prospectdetailsrow1" style={{ marginBottom: "20px" }}>
            <div>
              <Typography variant="caption"> RM Name </Typography>
              <Typography>{Prospect_Basic_info.Assigned_Executive}</Typography>
            </div>

            <div>
              <Typography variant="caption">EFG Score</Typography>
              <Typography variant="h6">
                {Prospect_Basic_info.EFG_Score}
              </Typography>
            </div>

            <div>
              <Typography variant="caption">
                Number of days to expiry{" "}
              </Typography>
              <Typography variant="h6">
                {Prospect_Basic_info.Daystoexpiry}
              </Typography>
            </div>

            <div>
              <Typography variant="caption">Demat</Typography>
              <Typography variant="h6">
                {Prospect_Basic_info.Broker !== null
                  ? Prospect_Basic_info.Broker
                  : "N/A"}
              </Typography>

              {/* <Typography variant="h6">{Prospect_Basic_info.Broker}</Typography> */}
            </div>
            <div>
              <Typography variant="caption">Tag</Typography>
              <Typography variant="h6">
                {/* {Prospect_Basic_info.tag !== null
                  ? Prospect_Basic_info.tag
                  : "N/A"} */}

                {Prospect_Basic_info.tag ? Prospect_Basic_info.tag : "Untagged"}

                {(localStorage.getItem("empRole") === "CTO" ||
                  localStorage.getItem("empRole") === "CEO") && (
                  <EditOutlinedIcon
                    onClick={toggleSelect}
                    style={{
                      cursor: "pointer",
                      verticalAlign: "middle",
                      width: 20,
                      height: 20,
                      marginLeft: 5,
                    }}
                  />
                )}
                {showPMsOPtions && (
                  <>
                    <div className="dropdown">
                      <div className="dropdown-content">
                        {tagData.map((item) => {
                          return (
                            <label>
                              <input
                                type="checkbox"
                                name={item.name}
                                id={item.name}
                                value={item.name}
                                onChange={
                                  item.name === "PIA" || item.name === "PMS"
                                    ? (e) => handlePmsRadioTag(e, item.name)
                                    : (e) => handlePmsTag(e, item.name)
                                }
                              />{" "}
                              {item.name}
                            </label>
                          );
                        })}
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ marginBottom: "1px" }}
                          onClick={saveSelectedTags}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  </>
                )}
              </Typography>

              {/* <Typography variant="h6">{Prospect_Basic_info.Broker}</Typography> */}
            </div>
          </div>
        </div>
      )}

      <label style={{ fontSize: 18 }}>Enter the GST number:</label>
      <input
        type="text"
        placeholder="Enter the GST number"
        style={{
          marginBottom: 20,
          marginLeft: 10,
          marginRight: 10,
          border: 0,
          borderBottom: "1px solid #000",
          width: 250,
          outline: 0,
        }}
        onChange={gstOnChange}
      />
      <Button
        onClick={submitGST}
        variant="contained"
        color="primary"
        style={{ marginBottom: 10 }}
      >
        Submit
      </Button>

      {(localStorage.getItem("empRole") === "CTO" ||
        localStorage.getItem("empRole") === "CEO" ||
        localStorage.getItem("empRole") === "Customer Delight Executive" ||
        localStorage.getItem("empRole") === "Business Growth Executive" ||
        localStorage.getItem("empRole") === "CRT Executive" ||
        localStorage.getItem("empRole") === "CRT Manager" ||
        localStorage.getItem("empRole") === "Sales Manager"|| localStorage.getItem("empRole") === "MF Manager" ||
        localStorage.getItem("empRole") === "MF Executive" || 
        localStorage.getItem("empRole") === "Sales and Retention Specialist" ||
        localStorage.getItem("empRole") === "Franchise" ) && (
        <>
          <div
            style={{
              display: "flex",
              marginBottom: "30px",
            }}
          >
            <TextField
              id="outlined-basic"
              placeholder="Add a Note"
              variant="outlined"
              multiline
              fullWidth
              value={noteval}
              maxRows={4}
              onChange={handleChange}
              inputProps={{
                maxlength: CHARACTER_LIMIT,
              }}
              helperText={`${noteval.length}/${CHARACTER_LIMIT}`}
            />
            <div>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#2835d5",
                  color: "#fff",
                  marginLeft: "10px",
                  height: "55px",
                  fontSize: "15px",
                }}
                onClick={handleUpdate}
              >
                Update
              </Button>
            </div>
          </div>
        </>
      )}

      {/* {localStorage.getItem("empRole") === "MF Manager" ||
      localStorage.getItem("empRole") === "MF Executive" ||
      localStorage.getItem("empRole") === "Franchise" ? (
        ""
      ) : ( */}
      <div
        className="userinfotab"
        onClick={editinvest}
        style={{ cursor: "pointer" }}
      >
        <p style={{ fontSize: "20px" }}>User Info</p>
        <p className="arrow">
          <ArrowForwardIcon className="innerarrow" />
        </p>
      </div>
      {/* )} */}

      <Grid container style={{ marginTop: "20px" }} className={"prospectgrids"}>
        <Grid item xs={12} sm={6} md={3}>
          <Paper className={classes.tile} onClick={gotoSubscriptionManager}>
            <Typography variant="h6">Subscription Manager</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper className={classes.tile} onClick={gotoPersonalProfile}>
            <Typography variant="h6">Personal Profile</Typography>
          </Paper>
        </Grid>
        {localStorage.getItem("empRole") === "MF Manager" ||
        localStorage.getItem("empRole") === "MF Executive" ||
        localStorage.getItem("empRole") === "Franchise" ? (
          ""
        ) : (
          <>
            <Grid item xs={12} sm={6} md={3}>
              <Paper className={classes.tile} onClick={gotoInvestmentProfile}>
                <Typography variant="h6">Investment Profile</Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Paper className={classes.tile} onClick={gotoRequestSection}>
                <Typography variant="h6">Requests Section</Typography>
              </Paper>
            </Grid>
          </>
        )}
      </Grid>
      {localStorage.getItem("empRole") === "MF Manager" ||
      localStorage.getItem("empRole") === "MF Executive" ||
      localStorage.getItem("empRole") === "Franchise" ? (
        <>
          <Grid
            container
            style={{ marginTop: "20px" }}
            className={"prospectgrids"}
          >
            <Grid item xs={12} sm={6} md={3} onClick={gotoNotesReviewPage}>
              <Paper className={classes.tile}>
                <Typography variant="h6">Notes</Typography>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Paper className={classes.tile} onClick={gotoActivityLog}>
                <Typography variant="h6">Activity Log</Typography>
              </Paper>
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Grid
            container
            style={{ marginTop: "20px" }}
            className={"prospectgrids"}
          >
            <Grid item xs={12} sm={6} md={3}>
              <Paper className={classes.tile} onClick={gotoGoalsDashBoard}>
                <Typography variant="h6">Goal Section</Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Paper className={classes.tile} onClick={gotoReferalDashboard}>
                <Typography variant="h6">Referral Dashboard</Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Paper className={classes.tile} onClick={gotoActivityLog}>
                <Typography variant="h6">Activity Log</Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={3} onClick={gotoProspectSatisfaction}>
              <Paper className={classes.tile}>
                <Typography variant="h6">Investor Satisfaction</Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={3} onClick={gotoNotesReviewPage}>
              <Paper className={classes.tile}>
                <Typography variant="h6">Notes</Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={3} onClick={gotoaddPaymentLinksPage}>
              <Paper className={classes.tile}>
                <Typography variant="h6">Payment Links</Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={3} onClick={gotoaddStatusTrackPage}>
              <Paper className={classes.tile}>
                <Typography variant="h6">Check-in Status Tracker</Typography>
              </Paper>
            </Grid>
          </Grid>
        </>
      )}

      {/* <Grid container style={{ marginTop: "30px" }} className={'prospectgrids'}>
                <Grid item xs={12} sm={12} md={6}>
                    <Grid item xs={12}>
                        <Typography  variant="h6">User Questionnaire  <EditOutlinedIcon onClick={editQuestioner} style={{cursor:"pointer"}}></EditOutlinedIcon> </Typography>
                    </Grid>
                    {
                        userQuestionnaire.map((obj,inx) => {
                            return (
                                <Grid container style={{ marginTop: "10px" }} key={inx+"ques"}>
                                    <Grid item xs={12}>
                                        <Typography  variant="caption">{obj["lable"]}</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography  variant="h6">{(Prospect_questionnaire[obj["value"]] &&
                                            Prospect_questionnaire[obj["value"]] === true) ?
                                            "Yes" : (Prospect_questionnaire[obj["value"]]) ?
                                                Prospect_questionnaire[obj["value"]] :
                                                Prospect_questionnaire[obj["value"]] === false ? "No" :
                                                    "N/A"}</Typography>
                                    </Grid>
                                </Grid>
                            )
                        })
                    }

                </Grid>

            </Grid> */}
      {/* <Grid container style={{ marginTop: "30px" }} >
            <Grid item xs={12} sm={6} md={6}>
            <Button style={Prospect_Basic_info.friendly?{backgroundColor:"#11be74" ,color:"#ffff", paddingLeft:50,paddingRight:50,borderRadius: "10px"}:{color:"rgb(106 106 106)", paddingLeft:50,paddingRight:50,borderRadius: "10px",backgroundColor:"#dbdbdb"}}
                         endIcon={Prospect_Basic_info.friendly||Prospect_Basic_info.friendly===null?<ThumbUpIcon />:<ThumbDownAltIcon />} onClick={setFriendlyBtn}>{Prospect_Basic_info.friendly||Prospect_Basic_info.friendly===null?"Very Friendly":"Not Friendly"}</Button>
                    
                    </Grid>
            </Grid> */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {Prospect_Basic_info.blocked ? "Unblock User" : "Block User"}
        </DialogTitle>
        <DialogContent>
          Are you sure to {Prospect_Basic_info.blocked ? "Unblock" : "Block"}{" "}
          {currentUser}?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            No
          </Button>
          <Button
            autoFocus
            onClick={(e) => submitBlock(e)}
            variant="contained"
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openGoalsModal}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {changebgColorGoalAdvice === 1
            ? "Block Goal Advice"
            : "Enable Goal Advice"}
        </DialogTitle>
        <DialogContent>
          {changebgColorGoalAdvice === 1 ? (
            <>
              Do you want to really block the goal advices for this{" "}
              {currentUser}?
            </>
          ) : (
            <>
              Do you really want to enable the goal advices to be sent for this{" "}
              {currentUser}?
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            No
          </Button>
          <Button
            autoFocus
            onClick={(e) => submitGoalAdvices(e)}
            variant="contained"
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openReferralModal}
        onClose={handleClose}
        className="referral_text"
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {ReferralLink !== null ? ReferralLink : "N/A"}
          {/* {Prospect_Basic_info.blocked ? "Unblock User" : "Block User"} */}
        </DialogTitle>
        <DialogContent>
          {/* Are you sure to {Prospect_Basic_info.blocked ? "Unblock" : "Block"}{" "} */}
          {/* {currentUser}? */}
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose} variant="outlined">
            No
          </Button> */}
          <Button
            autoFocus
            onClick={copyReferral}
            variant="contained"
            color="primary"
          >
            Copy to Clipboard
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openGstModel} style={{ padding: "30px" }}>
        <DialogActions>
          <CancelOutlined onClick={(e) => setOpenGstModel(false)} />
        </DialogActions>
        <DialogContentText style={{ padding: "30px" }}>
          <label>Enter your name</label>
          <br />
          <br />
          <input
            type="text"
            placeholder="Name"
            onChange={(e) => setGstCustName(e.target.value)}
            style={{
              width: "100%",
              outline: 0,
              border: 0,
              borderBottom: "1px solid black",
              fontSize: 16,
              marginBottom: 10,
            }}
          />

          <Button variant="contained" color="primary" onClick={submitGSTName}>
            Submit
          </Button>
        </DialogContentText>
      </Dialog>
    </Grid>
  );
}

export default InvestmentDetails;
